import React from "react";

interface FiltersClasseurProps {
  searchQuery: string;
  handleSearchChange: any;
  openModal: (modalname: string) => void;
  setFilterBar: (newvalue: boolean) => void;
  filterBar: boolean;
  setSelectedCreator: any;
  setSelectedGex: (newvalue: string) => void;
  isNotViewer: () => boolean;
  isGexpertise: () => boolean;
}
const FiltersClasseur = ({
  searchQuery,
  handleSearchChange,
  openModal,
  setFilterBar,
  filterBar,
  setSelectedCreator,
  setSelectedGex,
  isNotViewer,
  isGexpertise,
}: FiltersClasseurProps) => {
  return (
    <div className="mt-6 md:flex md:items-end md:justify-between">
      <form className="flex items-center">
        <label htmlFor="simple-search" className="sr-only">
          Search
        </label>

        <div className="relative w-full">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <svg
              aria-hidden="true"
              className="w-5 h-5 text-gray-500 dark:text-gray-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clipRule="evenodd"
              ></path>
            </svg>
          </div>
          <input
            type="text"
            id="simple-search"
            className="block p-2 pl-10 text-md text-gray-900 border border-gray-300 rounded-lg w-80  focus:ring-gexpertise-200 focus:border-gexpertise-200 "
            placeholder="Recherche"
            value={searchQuery}
            onChange={handleSearchChange}
          ></input>
        </div>
      </form>
      <div className="flex space-x-2">
        {(isNotViewer() && !isGexpertise()) &&(
          <button
            onClick={() => openModal("add")}
            className="flex justify-center  px-5 py-2 text-md tracking-wide text-white transition-colors duration-200 bg-gexpertise-100 rounded-lg shrink-0 sm:w-auto gap-x-2 hover:bg-gexpertise-200 "
          >
            <img
              src="images/plus.png"
              className="inline-block h-3 mr-3 mt-1 flex-none"
              alt="plus"
            />
            Classeur
          </button>
        )}
        <button
          onClick={() => {
            setFilterBar(!filterBar);
            setSelectedCreator(null);
            setSelectedGex("");
          }}
          className="flex items-center justify-center  px-5 py-2 text-md text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto dark:hover:bg-gray-800 dark:bg-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:border-gray-700"
        >
          <img src="/images/sort.png" />
          Filtres
        </button>
      </div>
    </div>
  );
};

export default FiltersClasseur;
